import moment from 'moment';
import 'moment/locale/pt-br';

// Extratos bancários dos clientes (CON-325). O status vem pronto da API; aqui
// só a cara de cada um. Verde e vermelho seguem o que o cliente vê no portal.
export const STATUS = {
  entregue: { label: 'Entregue', short: '✓', color: '#1E7B45', background: '#1E7B45', text: '#ffffff' },
  nao_entregue: { label: 'Não entregue', short: '!', color: '#B42318', background: '#B42318', text: '#ffffff' },
  em_conferencia: { label: 'Enviado, falta conferir', short: '↑', color: '#1F5FAD', background: '#1F5FAD', text: '#ffffff' },
  sem_movimento: { label: 'Sem movimento', short: 's/m', color: '#4A5163', background: '#EEF0F3', text: '#4A5163' },
  pendente: { label: 'Aguardando envio', short: '', color: '#8c8c8c', background: '#ffffff', text: '#8c8c8c', border: '#C9CDD6' },
  aberto: { label: 'Mês em andamento', short: '', color: '#8c8c8c', background: '#ffffff', text: '#8c8c8c', border: '#C9CDD6', dashed: true },
  futuro: { label: 'Mês futuro', short: '', color: '#bfbfbf', background: '#FAF8FD', text: '#bfbfbf', border: '#EEE7F8' },
  fora: { label: 'Antes do início do cliente', short: '', color: '#bfbfbf', background: '#E8E8E8', text: '#8c8c8c', border: '#E8E8E8' }
};

export const statusOf = (status) => STATUS[status] || STATUS.pendente;

export const MONTH_HEADS = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

export const monthLabel = (competence) => {
  const label = moment(competence + '-01').locale('pt-br').format('MMMM/YYYY');
  return label.charAt(0).toUpperCase() + label.slice(1);
};

export const cellStyle = (status, isOpen) => {
  const look = statusOf(status);
  const border = look.border || look.background;
  return {
    width: '100%',
    height: 34,
    borderRadius: 6,
    border: (look.dashed ? '1px dashed ' : '1px solid ') + border,
    background: look.background,
    color: look.text,
    fontWeight: 700,
    fontSize: 12,
    cursor: status === 'fora' ? 'default' : 'pointer',
    boxShadow: isOpen ? '0 0 0 2px #722ed1' : 'none',
    padding: 0
  };
};

export const firstError = (error, fallback) => {
  const data = error && error.response && error.response.data;
  if (data && data.errors) {
    const keys = Object.keys(data.errors);
    if (keys.length && data.errors[keys[0]] && data.errors[keys[0]][0]) {
      return data.errors[keys[0]][0];
    }
  }
  return (data && data.message) || fallback;
};
